import 'react-toastify/dist/ReactToastify.css';
import { DapService } from '../../service/dap.service';
import { getConstants } from './actionType';

function DAPList(page, searchValue, filterValue, sort) {
    function request(user) { return { type: getConstants.GET_ALL_DAP_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_ALL_DAP_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_DISTRIBUTORS_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await DapService.DAPList(page, searchValue, filterValue, sort);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}

export const DApActions = {
    DAPList,

};
